import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { authErrors } from './../../core/errors';
import { AlertService } from './../../core/services/alert.service';
import { LoadingService } from './../../core/services/loading.service';
import { RoleService } from './../../core/services/role.service';
declare const $: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  credentials = {
    email: '',
    password: ''
  };
  resetPassword = {
    email: '',
    code: '',
    password: '',
    passwordAgain: '',
    step: 0
  }
  loginForm: FormGroup;
  constructor(
    private authService: AuthService,
    private router: Router,
    private alertService: AlertService,
    private loadingService: LoadingService,
    private roleService: RoleService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    const token = this.authService.getToken();
    if (token) {
      this.router.navigate(['/']);
    }
    this.loginForm = this.formBuilder.group({
      email: new FormControl('', Validators.compose([Validators.required,
        Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        ])),
      password: new FormControl('', [
        Validators.required
      ])
    })
  }

  async login() {
    if (this.loginForm.invalid) {
      this.alertService.alert('Hata', 'Lütfen bilgilerinizi doğru bir şekilde giriniz!', 'error')
      console.log("invalid!")
      return;
    }
    if (this.loginForm.valid) {
      let dataObj = Object.assign({}, this.loginForm.value);
      this.credentials.email = dataObj.email;
      this.credentials.password = dataObj.password;
      const data: any = await this.authService.getUserToken().toPromise();
      this.loadingService.setLoading(true);
      this.authService.login(this.credentials, data.token).subscribe(response => {
        if (response.success) {
          this.alertService.alert('Başarılı', '', 'success');
          console.log(response);
          this.authService.saveUserToLocalStorage(response);
          this.roleService.getCurrentUserRoles(response.user.roleId).subscribe(response => {
             this.router.navigate(['/']);
          })
        } else {
          this.alertService.alert('Hata!', response.errors[0], 'error');
        }
        this.loadingService.setLoading(false);
      }, (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      })
    }
    
  }

  showPasswordModal() {
    this.resetPassword = {
      email: '',
      code: '',
      password: '',
      passwordAgain: '',
      step: 0
    }
    $('.modal').modal('show');
  }
  hidePasswordModal() {
    this.resetPassword = {
      email: '',
      code: '',
      password: '',
      passwordAgain: '',
      step: 0
    }
    $('.modal').modal('hide');
  }

  sendCode() {
    this.authService.sendCode(this.resetPassword.email).subscribe(response => {
      if (response.success) {
        this.alertService.alert('Başarılı!', 'Kod mail adresinize başarıyla gönderildi.', 'success');
        this.resetPassword.step = 1;
      } else {
        this.alertService.alert('Hata!', 'Kullanıcı bulunamadı.', 'error');
      }
    });
  }
  changePassword() {
    this.authService.changePassword(this.resetPassword.email, this.resetPassword.code, this.resetPassword.passwordAgain).subscribe(response => {
      if (response.success) {
        this.alertService.alert('Başarılı!', 'Şifreniz başarıyla değiştirildi.', 'success');
        this.hidePasswordModal();
      } else {
        this.alertService.alert('Hata!', 'Kodu kontrol ediniz..', 'error');
      }
    });
  }

  get f() {
    return this.loginForm.controls;
  }
}
